import {defineStore} from 'pinia'
import {ref, computed, reactive} from 'vue'

export const useMatchedBetStore = defineStore('MatchedBetStore', () => {
    const basicMatchedBetTypes = [
        {value: 'qualifying', label: 'Qualifying Bet'},
        {value: 'fb-sr', label: 'Free Bet (SR)'},
        {value: 'fb-snr', label: 'Free Bet (SNR)'},
        {value: 'rf', label: 'Risk Free'},
    ];


    const backBetData = reactive({
        type: 'qualifying',
        stake: '',
        odds: '',
        lossValue: 0,
        commission: 0,
    })

    const layBetData = reactive({
        odds: '',
        commission: 2,
    })

    const oddsmatcherData = reactive(({
        eventDescription: null,
        eventStart: null,
        outcome: null,
        bookie: null,
        maxLiability: '',
        minOdds: '0',
        exchangeDisplayName: null,
    }))

    function getLayStake(backData = backBetData, layData = layBetData) {
        const backOdds = parseFloat(backData.odds) || 0
        const layOdds = parseFloat(layData.odds) || 0
        if (layOdds === 0) return 0
        let backStake = parseFloat(backData.stake);
        const backCommission = parseFloat(backData.commission) || 0;
        const rfv = parseFloat(backData.lossValue) || 0;
        const backMultiplier = 1 - (backCommission / 100);
        const layCommission = parseFloat(layData.commission) || 0;

        // Check if any of the required data is missing or invalid
        if (isNaN(backStake) || isNaN(backOdds) || isNaN(layOdds)) {
            return 0;
        }

        let backReturn = (backOdds - 1) * backStake * backMultiplier + backStake;
        let layStake;
        const betType = backData.type;

        if (betType === 'rf') {
            layStake = ((backReturn - rfv) / (layOdds - layCommission / 100)).toFixed(2);
        } else {
            if (betType === 'fb-snr') {
                backReturn = backStake * backMultiplier * (backOdds - 1);
            }
            layStake = (backReturn / (layOdds - layCommission / 100)).toFixed(2);
        }

        return Number(layStake);
    }

    function getLiability(layStake, layOdds) {
        return layStake * (layOdds - 1)
    }

    const getResults = (backData = backBetData, layData = layBetData) => {
        const results = {}

        // Ensure all numeric values are parsed to floats
        const backOdds = parseFloat(backData.odds) || 0
        const backStake = parseFloat(backData.stake) || 0;
        results.backStake = backStake
        const backLossValue = parseFloat(backData.lossValue) || 0;
        const backCommission = parseFloat(backData.commission) || 0;
        const layOdds = parseFloat(layData.odds) || 0
        const layCommission = parseFloat(layData.commission) || 0;
        const layStake = layData.stake ?
            layData.stake
            : parseFloat(getLayStake(backData, layData)) || 0;
        const liability = parseFloat(getLiability(layStake, layOdds)) || 0
        results.layStake = layStake

        results.backWin = backData.type === 'fb-sr'
            ? (backStake * (backOdds - 1)) * (1 - (backCommission / 100)) + backStake
            : (backStake * (backOdds - 1)) * (1 - (backCommission / 100))


        results.backLoss = backData.type === 'fb-snr' || backData.type === 'fb-sr'
            ? 0
            : -backStake

        results.backCashback = backData.type === 'rf'
            ? backLossValue
            : 0

        results.layWin = layStake * (1 - (layCommission / 100))

        results.layLoss = -liability

        results.totalBackWin = results.backWin + results.layLoss
        results.totalLayWin = results.layWin + results.backCashback + results.backLoss
        results.profit = Math.min(results.totalBackWin, results.totalLayWin)
        return results;
    }


    return {basicMatchedBetTypes, backBetData, layBetData, oddsmatcherData, getLayStake, getLiability, getResults}
})
